module.exports = __webpack_public_path__ + "assets/door-32-focus.svg";